export const emoji_sad = () => (
  <path
    d="M8 16s1.5-2 4-2 4 2 4 2m-7-5h.01M15 11h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
